import { FC } from "react"
import { useSearchParams } from "react-router-dom"
import { useFindContactFormsQuery } from "../../../../redux/queries"
import { Brand } from "../../../../types"
import BrandAutocomplete from "../../brand-autocomplete"
import ContactFormTable from "./table"

interface Props {
  brands: Brand[]
}

const ConfigContactForm: FC<Props> = ({ brands }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const selectedBrandId = searchParams.get("brand_id") ?? ""

  const setSelectedBrandId = (id: string) => {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev)
      if (id) next.set("brand_id", id)
      else next.delete("brand_id")
      return next
    })
  }

  const { data: contactForms, isFetching } = useFindContactFormsQuery(
    selectedBrandId,
    { skip: !selectedBrandId }
  )

  return (
    <div>
      <BrandAutocomplete
        brands={brands}
        selected={selectedBrandId}
        onChange={setSelectedBrandId}
      />

      <div className="pt-6">
        {selectedBrandId ? (
          <ContactFormTable data={contactForms ?? []} isFetching={isFetching} />
        ) : null}
      </div>
    </div>
  )
}

export default ConfigContactForm
